
export const portfolios=[
    {
        id: 1,
        name: "Seerat",
        properties: 1,
        value: "value 1",
        address: "Jutial Gilgit",
        phoneNumber: "0312344",
    },
    {
        id: 2,
        name: "rhetttullis",
        properties: 2,
        value: "value 2",
        address: "PO Box 145",
        phoneNumber: "(405) 283-6521",
    },
]